// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outgoing-table-container {
  max-height: calc(100vh - 300px);
  overflow: auto !important;
  width: 100%;
  position: relative;
  -webkit-overflow-scrolling: touch;
}

.outgoing-table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  display: block !important;
}

.outgoing-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.outgoing-table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.outgoing-table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.outgoing-table {
  width: 100%;
  min-width: 850px;
  table-layout: fixed;
}

.outgoing-table td {
  vertical-align: middle !important;
}

.outgoing-table th {
  vertical-align: middle !important;
}

.outgoing-table th.col-actions,
.outgoing-table td.col-actions {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
  white-space: nowrap;
  overflow: visible;
  padding: 0.5rem !important;
  vertical-align: middle !important;
}

.outgoing-table th.col-currency,
.outgoing-table td.col-currency {
  width: auto;
  min-width: 40px;
  max-width: 50px;
  white-space: nowrap;
}

.outgoing-table th.col-amount,
.outgoing-table td.col-amount {
  width: auto;
  min-width: 55px;
  max-width: 70px;
  white-space: nowrap;
}

.outgoing-table th:nth-child(7),
.outgoing-table td:nth-child(7) {
  width: auto;
  min-width: 60px;
  max-width: 80px;
  white-space: nowrap;
}

.outgoing-table-container-monazam {
  max-height: calc(100vh - 300px);
  overflow: auto !important;
  width: 100%;
  position: relative;
  -webkit-overflow-scrolling: touch;
}

.outgoing-table-container-monazam::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  display: block !important;
}

.outgoing-table-container-monazam::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.outgoing-table-container-monazam::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.outgoing-table-container-monazam::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.outgoing-table-monazam-portal {
  width: 100%;
  min-width: 800px;
  table-layout: fixed;
}

.outgoing-table-monazam-portal td {
  vertical-align: middle !important;
}

.outgoing-table-monazam-portal th {
  vertical-align: middle !important;
}

.outgoing-table-monazam-portal th.col-currency,
.outgoing-table-monazam-portal td.col-currency {
  width: 25px !important;
  min-width: 25px !important;
  max-width: 25px !important;
  padding: 0.5rem 0.15rem !important;
}

.outgoing-table-monazam-portal th.col-amount,
.outgoing-table-monazam-portal td.col-amount {
  width: 40px !important;
  min-width: 40px !important;
  max-width: 40px !important;
  padding: 0.5rem 0.15rem !important;
}

.outgoing-table-monazam-portal th.col-actions,
.outgoing-table-monazam-portal td.col-actions {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
  white-space: nowrap;
  overflow: visible;
  padding: 0.5rem !important;
  vertical-align: middle !important;
}

.outgoing-table-monazam th:nth-child(7),
.outgoing-table-monazam td:nth-child(7) {
  width: auto;
  min-width: 60px;
  max-width: 80px;
}

.outgoing-table-hgo th.col-currency,
.outgoing-table-hgo td.col-currency {
  width: auto;
  min-width: 40px;
  max-width: 50px;
}

.outgoing-table-hgo th.col-amount,
.outgoing-table-hgo td.col-amount {
  width: auto;
  min-width: 55px;
  max-width: 70px;
}

.outgoing-table-hgo th:nth-child(7),
.outgoing-table-hgo td:nth-child(7) {
  width: auto;
  min-width: 60px;
  max-width: 80px;
}

.status-text {
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-success {
  color: #28a745 !important;
}

.text-danger {
  color: #dc3545 !important;
}

.text-muted {
  color: #6c757d !important;
}

.action-buttons {
  flex-wrap: nowrap;
  gap: 0.3rem;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  display: flex;
}

.approved-btn,
.rejectbtn {
  font-size: 11px;
  padding: 0.2rem 0.5rem;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: auto;
  margin: 0;
}

@media (max-width: 1023px) {
  .outgoing-table-container {
    max-height: calc(100vh - 250px);
  }
  
  .outgoing-table {
    min-width: 700px;
  }
  
  .outgoing-table th.col-actions,
  .outgoing-table td.col-actions {
    width: 140px;
    min-width: 140px;
    max-width: 140px;
  }
  
  .action-buttons {
    flex-wrap: wrap;
    gap: 0.25rem;
  }
  
  .approved-btn,
  .rejectbtn {
    font-size: 10px;
    padding: 0.15rem 0.4rem;
    flex: 0 1 auto;
  }
  
  .outgoing-table th.col-currency,
  .outgoing-table td.col-currency {
    width: auto;
    min-width: 50px;
    max-width: 60px;
  }
  
  .outgoing-table th.col-amount,
  .outgoing-table td.col-amount {
    width: auto;
    min-width: 70px;
    max-width: 90px;
  }
}

@media (min-width: 1024px) {
  .outgoing-table-container {
    overflow-x: auto;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/Outgoing/OutgoingComponents/Table.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;;IAEE,eAAe;IACf,uBAAuB;IACvB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".outgoing-table-container {\n  max-height: calc(100vh - 300px);\n  overflow: auto !important;\n  width: 100%;\n  position: relative;\n  -webkit-overflow-scrolling: touch;\n}\n\n.outgoing-table-container::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  display: block !important;\n}\n\n.outgoing-table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.outgoing-table-container::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.outgoing-table-container::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.outgoing-table {\n  width: 100%;\n  min-width: 850px;\n  table-layout: fixed;\n}\n\n.outgoing-table td {\n  vertical-align: middle !important;\n}\n\n.outgoing-table th {\n  vertical-align: middle !important;\n}\n\n.outgoing-table th.col-actions,\n.outgoing-table td.col-actions {\n  width: 200px !important;\n  min-width: 200px !important;\n  max-width: 200px !important;\n  white-space: nowrap;\n  overflow: visible;\n  padding: 0.5rem !important;\n  vertical-align: middle !important;\n}\n\n.outgoing-table th.col-currency,\n.outgoing-table td.col-currency {\n  width: auto;\n  min-width: 40px;\n  max-width: 50px;\n  white-space: nowrap;\n}\n\n.outgoing-table th.col-amount,\n.outgoing-table td.col-amount {\n  width: auto;\n  min-width: 55px;\n  max-width: 70px;\n  white-space: nowrap;\n}\n\n.outgoing-table th:nth-child(7),\n.outgoing-table td:nth-child(7) {\n  width: auto;\n  min-width: 60px;\n  max-width: 80px;\n  white-space: nowrap;\n}\n\n.outgoing-table-container-monazam {\n  max-height: calc(100vh - 300px);\n  overflow: auto !important;\n  width: 100%;\n  position: relative;\n  -webkit-overflow-scrolling: touch;\n}\n\n.outgoing-table-container-monazam::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  display: block !important;\n}\n\n.outgoing-table-container-monazam::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.outgoing-table-container-monazam::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.outgoing-table-container-monazam::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.outgoing-table-monazam-portal {\n  width: 100%;\n  min-width: 800px;\n  table-layout: fixed;\n}\n\n.outgoing-table-monazam-portal td {\n  vertical-align: middle !important;\n}\n\n.outgoing-table-monazam-portal th {\n  vertical-align: middle !important;\n}\n\n.outgoing-table-monazam-portal th.col-currency,\n.outgoing-table-monazam-portal td.col-currency {\n  width: 25px !important;\n  min-width: 25px !important;\n  max-width: 25px !important;\n  padding: 0.5rem 0.15rem !important;\n}\n\n.outgoing-table-monazam-portal th.col-amount,\n.outgoing-table-monazam-portal td.col-amount {\n  width: 40px !important;\n  min-width: 40px !important;\n  max-width: 40px !important;\n  padding: 0.5rem 0.15rem !important;\n}\n\n.outgoing-table-monazam-portal th.col-actions,\n.outgoing-table-monazam-portal td.col-actions {\n  width: 200px !important;\n  min-width: 200px !important;\n  max-width: 200px !important;\n  white-space: nowrap;\n  overflow: visible;\n  padding: 0.5rem !important;\n  vertical-align: middle !important;\n}\n\n.outgoing-table-monazam th:nth-child(7),\n.outgoing-table-monazam td:nth-child(7) {\n  width: auto;\n  min-width: 60px;\n  max-width: 80px;\n}\n\n.outgoing-table-hgo th.col-currency,\n.outgoing-table-hgo td.col-currency {\n  width: auto;\n  min-width: 40px;\n  max-width: 50px;\n}\n\n.outgoing-table-hgo th.col-amount,\n.outgoing-table-hgo td.col-amount {\n  width: auto;\n  min-width: 55px;\n  max-width: 70px;\n}\n\n.outgoing-table-hgo th:nth-child(7),\n.outgoing-table-hgo td:nth-child(7) {\n  width: auto;\n  min-width: 60px;\n  max-width: 80px;\n}\n\n.status-text {\n  font-size: 14px;\n  font-weight: 400;\n  white-space: nowrap;\n  display: inline-block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.text-success {\n  color: #28a745 !important;\n}\n\n.text-danger {\n  color: #dc3545 !important;\n}\n\n.text-muted {\n  color: #6c757d !important;\n}\n\n.action-buttons {\n  flex-wrap: nowrap;\n  gap: 0.3rem;\n  width: 100%;\n  justify-content: flex-start;\n  align-items: center;\n  display: flex;\n}\n\n.approved-btn,\n.rejectbtn {\n  font-size: 11px;\n  padding: 0.2rem 0.5rem;\n  white-space: nowrap;\n  flex-shrink: 0;\n  min-width: auto;\n  margin: 0;\n}\n\n@media (max-width: 1023px) {\n  .outgoing-table-container {\n    max-height: calc(100vh - 250px);\n  }\n  \n  .outgoing-table {\n    min-width: 700px;\n  }\n  \n  .outgoing-table th.col-actions,\n  .outgoing-table td.col-actions {\n    width: 140px;\n    min-width: 140px;\n    max-width: 140px;\n  }\n  \n  .action-buttons {\n    flex-wrap: wrap;\n    gap: 0.25rem;\n  }\n  \n  .approved-btn,\n  .rejectbtn {\n    font-size: 10px;\n    padding: 0.15rem 0.4rem;\n    flex: 0 1 auto;\n  }\n  \n  .outgoing-table th.col-currency,\n  .outgoing-table td.col-currency {\n    width: auto;\n    min-width: 50px;\n    max-width: 60px;\n  }\n  \n  .outgoing-table th.col-amount,\n  .outgoing-table td.col-amount {\n    width: auto;\n    min-width: 70px;\n    max-width: 90px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .outgoing-table-container {\n    overflow-x: auto;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
